define('ZipCodeSelector', ['ShippingByLocation', 'ZipCodeSelector.View'], function ZipCodeSelector(
  ShippingByLocation,
  ZipCodeSelectorView
) {
  'use strict';

  return {
    /**
     * @param {ComponentContainer} container
     */
    mountToApp: function mountToApp(container) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');

      this.addChildView(container, pdp.PDP_QUICK_VIEW);
      this.addChildView(container, pdp.PDP_FULL_VIEW);
    },

    /**
     * @param {ComponentContainer} container
     * @param {String} viewId
     */
    addChildView: function addChildView(container, viewId) {
      /** @type PDP */
      var pdp = container.getComponent('PDP');
      var environment = container.getComponent('Environment');

      pdp.addChildViews(viewId, {
        'Product.Options': {
          ZipCodeSelector: {
            childViewConstructor: function LocationsTableViewConstructor() {
              var model = ShippingByLocation.forCurrentProduct(container);
              var view = new ZipCodeSelectorView({
                model: model,
                environment: environment
              });
              model.setup().done(function doneLoad() {
                view.render();
              });
              return view;
            }
          }
        }
      });
    }
  };
});
